<template>
  <section>
    <!-- <Hero /> -->
    <h2>Projects</h2>
    <!-- <ProjectDetail></ProjectDetail> -->
    <p>
      A collection of projects showcasing graphic design, ux/ui work,
      development and process documents.
    </p>
    <div class="flex-wrapper">
      <div
        v-for="project in projects"
        v-bind:key="project.id"
        class="project__tile"
      >
        <router-link
          class="project__link"
          :to="{
            name: 'ProjectDetail',
            params: {
              name: project.slug,
              slug: project.name,
              id: project.id,
              thumb: project.thumb,
              imgTitle01: project.imgTitle01,
              imgPath01: project.imgPath01,
              imgTitle02: project.imgTitle02,
              imgPath02: project.imgPath02,
              imgTitle03: project.imgTitle03,
              imgPath03: project.imgPath03,
              imgTitle04: project.imgTitle04,
              imgPath04: project.imgPath04,
              imgTitle05: project.imgTitle05,
              imgPath05: project.imgPath05,
              descriptionShort: project.descriptionShort,
              descriptionLong: project.descriptionLong,
            },
          }"
        >
          <!-- </router-link> -->
          <!-- <router-link
          v-bind:to="project.link"
          v-bind:key="project.id"
          class="project__link"
        > -->
          <img class="project__thumb" v-bind:src="project.thumb" />

          <!-- <router-view></router-view> -->
          <div class="project__info">
            <p class="project__name">{{ project.name }}</p>
            <p class="project__descriptionShort">
              {{ project.descriptionShort }}
            </p>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
  import { projects } from "../../data.js"
  import Hero from "@/components/Hero.vue"
  import ProjectDetail from "@/components/resume/ProjectDetail.vue"

  export default {
    name: "Projects",
    // props: [projects],
    components: {
      Hero,
      ProjectDetail,
    },
    data() {
      return {
        projects,
      }
    },
    // mounted() {
    // },
  }
</script>

<style lang="scss">
  @import "./src/scss/style--light";
</style>
